import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';
import type { Address } from '../../../contracts';
import type { RootState } from '../../../store/types';
import { personalDetailsSelectors } from '../ducks';
import { TabContent } from '../../../routes/RouterOutlet.styles';
import PageTitle from '../../../shared/components/PageTitle';
import EditAddressForm from '../EditAddressForm/EditAddressForm';
import { getDisplayNameByPath } from '../../../utilities';
import LoadingPage from '../../../shared/components/LoadingPage';
import ErrorPage from '../../../shared/components/ErrorPage';
import EditDisclaimer from '../../../shared/components/EditDisclaimer';

type OwnProps = {
  location?: { pathname: string };
};

type StateProps = {
  address: Address | null;
  isLoadingPersonalDetails: boolean;
  isOrderPlaced: boolean;
  personalDetailsError: Record<string, unknown>;
  sectionName: string;
};

const EditDeliveryAddress = ({
  address,
  sectionName,
  isLoadingPersonalDetails,
  personalDetailsError,
  isOrderPlaced
}: OwnProps & StateProps) => {
  if (!address) return null;

  const hasError = !isEqual(personalDetailsError, {});
  const shouldShowError = !isLoadingPersonalDetails && hasError;
  const shouldShowComponent = !isLoadingPersonalDetails && !hasError;

  return (
    <>
      <PageTitle title="Edit Delivery Address" />
      {isOrderPlaced && <EditDisclaimer />}
      {isLoadingPersonalDetails && <LoadingPage />}
      {shouldShowError && <ErrorPage />}

      {shouldShowComponent && (
        <TabContent>
          <EditAddressForm requestKind="DeliveryOnly" address={address} sectionName={sectionName} />
        </TabContent>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
  sectionName: getDisplayNameByPath(ownProps?.location?.pathname ?? ''),
  address: personalDetailsSelectors.getDeliveryAddress(state),
  isLoadingPersonalDetails: personalDetailsSelectors.getIsLoadingPersonalDetails(state),
  personalDetailsError: personalDetailsSelectors.getPersonalDetailsError(state),
  isOrderPlaced: personalDetailsSelectors.getIsOrderPlaced(state)
});

export default connect(mapStateToProps)(EditDeliveryAddress);
